// extracted by mini-css-extract-plugin
export default {"premiumCrown":"VUlTSTBAg4hipwwBeU3Y"};